<div class="form-row m-0">
	<div class="position-relative w-100">
		<mat-form-field appearance="outline" class="w-100">
			<input
				type="text"
				[placeholder]="elementPlaceholder"
				matInput
				[(ngModel)]="elementLabel"
				[formControl]="elementControl"
				[matAutocomplete]="elements"
			/>
			<mat-autocomplete #elements="matAutocomplete" (optionSelected)="emitElement($event.option.value)">
				<mat-option *ngFor="let option of elementOptions | async" [value]="option">
					{{ getOptionDesc(option) }}
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>
